import { AudioTargetProps } from "./types";
import MusicVideoIcon from "@mui/icons-material/MusicVideo";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import ReplayIcon from "@mui/icons-material/Replay";
import EditIcon from "@mui/icons-material/Edit";
import { APP_BACKGROUND_COLOR, TEXT_COLOR } from "../../theme";

export const AudioTarget: React.FC<AudioTargetProps> = ({
  url,
  dawExportedBlob,
  errors,
  touched,
  handleDragOver,
  onDragAudio,
  onAddAudio,
  handleBlur,
  isSubmitting,
  filename,
  playingState,
  playAudio,
  pauseAudio,
  reset,
}) => {
  return (
    <>
      <div className="audio-target">
        {url === undefined && dawExportedBlob === undefined ? (
          <label
            htmlFor="songUpload"
            className="image-upload"
            style={{
              height: 155,
              borderStyle: url ? "none" : "dashed",
              borderWidth: "2px",
              borderColor:
                errors.songUpload && touched.songUpload ? "red" : TEXT_COLOR,
            }}
            onDragOver={handleDragOver}
            onDrop={onDragAudio}
          >
            <input
              type="file"
              name="songUpload"
              id="songUpload"
              onChange={onAddAudio}
              accept=".mp3,.wav,.ogg"
              onBlur={handleBlur}
              disabled={isSubmitting}
            />
            <MusicVideoIcon sx={{ width: "50px", height: "50px" }} />
          </label>
        ) : (
          <div
            className="audio-player"
            onDragOver={handleDragOver}
            onDrop={onDragAudio}
            style={{ backgroundColor: APP_BACKGROUND_COLOR }}
          >
            <div className="content">
              <p style={{ color: TEXT_COLOR }} className="audio-name">
                {filename}
              </p>

              <div className="range">
                <p style={{ color: TEXT_COLOR }} className="playTime">
                  <span className="minutes">00</span>
                  <span>:</span>
                  <span className="seconds">00</span>
                </p>
                <input
                  type="range"
                  name="audio"
                  id="audio-point"
                  min="0"
                  max="27"
                  // de="0"
                />
                <p style={{ color: TEXT_COLOR }} className="duration">
                  <span className="minutes">00</span>
                  <span>:</span>
                  <span className="seconds">00</span>
                </p>
              </div>

              <div style={{ color: TEXT_COLOR }} className="controls">
                {playingState === "stop" && (
                  <PlayArrowIcon
                    style={{ cursor: "pointer" }}
                    className="audio-play"
                    onClick={playAudio}
                  />
                )}
                {playingState === "playing" && (
                  <PauseIcon
                    style={{ cursor: "pointer" }}
                    className="audio-pause"
                    onClick={pauseAudio}
                  />
                )}
                {playingState === "end" && (
                  <ReplayIcon
                    style={{ cursor: "pointer" }}
                    className="audio-reset"
                    onClick={reset}
                  />
                )}
              </div>
            </div>
            <label className="image-edit">
              <input
                type="file"
                name="songUpload"
                id="songUpload"
                onChange={onAddAudio}
                accept=".mp3,.wav,.ogg"
                onBlur={handleBlur}
                disabled={isSubmitting}
              />
              <div>
                <EditIcon sx={{ color: TEXT_COLOR }} />
              </div>
            </label>
          </div>
        )}
      </div>
    </>
  );
};
